const noop = () => {};
export const createServer = noop;
export const createConnection = noop;
export const connect = noop;
export const isIP = noop;
export const isIPv4 = noop;
export const isIPv6 = noop;
